import React from "react";
import { Stepper, Step, StepLabel, StepContent, Typography, Chip, Box } from "@mui/material";
 import { useTheme } from "@mui/material/styles";
 import PropTypes from "prop-types";

const statusColor = {
  wait: "warning",
  finish: "success",
  error: "error"
};
const statusLabel = {
  wait: "Pending",
  finish: "Approved",
  error: "Rejected"
};
 
export default function ApprovalFlow({ steps, isDeployed }) {
   const theme = useTheme();
  if (!steps || steps.length === 0) return null;
 
  // Check if all approval steps are finished (approved)
  const allApproved = steps.every(step => step.status === "finish");
 
  let displaySteps = [...steps];
 
  // Append a step if all are approved or deployed
  if (allApproved && isDeployed) {
    displaySteps.push({
      title: "SRE",
      status: "finish",
      comment: "Resource has been deployed.",
      isFinal: true
    });
  } else if (allApproved && !isDeployed) {
    displaySteps.push({
      title: "Ready for Deployment",
      status: "finish",
      comment: "All approvals complete. Ready to deploy.",
      isFinal: true
    });
  }
 
  const activeStep = displaySteps.findIndex((step) => step.status !== "finish");
 
  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
        Track Approval Status
      </Typography>
      <Stepper
        activeStep={activeStep === -1 ? displaySteps.length : activeStep}
        orientation="vertical"
 sx={{ bgcolor: theme.palette.background.commentBg , p: 2, borderRadius: 2 }}      >
        {displaySteps.map((step, idx) => (
          <Step key={idx}>
            <StepLabel
              optional={
               
                <Chip
  label={
    step.title === "Ready for Deployment"
      ? "All Set"
      : step.title === "SRE"
        ? "Deployed"
        : statusLabel[step.status]
  }
  color={
    step.title === "Ready for Deployment" || step.title === "Deployed"
      ? "success"
      : statusColor[step.status]
  }
  size="small"
  variant="filled"
  sx={{
    fontWeight: "bold",
    color: "#fff"
  }}
/>
 
              }
            >
              {step.title}
            </StepLabel>
            <StepContent>
              {step.comment && (
                <Typography variant="body2" color="text.secondary">{step.comment}</Typography>
              )}
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
 
ApprovalFlow.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      status: PropTypes.oneOf(["wait", "finish", "error"]).isRequired,
      comment: PropTypes.string,
      isFinal: PropTypes.bool,
    })
  ).isRequired,
  isDeployed: PropTypes.bool,
};